import { PricePricingMode } from '../../constants/price-pricing-mode.js';
import { derivePriceScopeType, LOCKED_PRICE_PRIORITY, PRICE_RULE_PRIORITY_BY_SCOPE, } from '../../pricing/index.js';
import { isSet } from './is-set.js';
/**
 * Wraps setPrice's three derived PriceRule header fields (revision doc §8) so validation and the
 * resolver read from one source: scopeTypeId from which of customerId/productId is set,
 * priority from the scope band (or LOCKED_PRICE_PRIORITY when locked), and pricingModeId from
 * whether any amount carries a payment term or a term group -- VARIABLE if so, STATIC otherwise.
 * amountTypeId plays no part in this derivation; a list/msrp-only call still yields a real
 * pricingModeId because every amount row (regardless of type) carries the same term/group shape.
 */
export function derivePriceRuleFields(input) {
    const scopeTypeId = derivePriceScopeType(input.customerId ?? null, input.productId ?? null);
    const priority = input.locked ? LOCKED_PRICE_PRIORITY : PRICE_RULE_PRIORITY_BY_SCOPE[scopeTypeId];
    const pricingModeId = input.amounts.some((amount) => isSet(amount.paymentTermsId) || amount.paymentTermsGroupId != null)
        ? PricePricingMode.VARIABLE
        : PricePricingMode.STATIC;
    return { scopeTypeId, priority, pricingModeId };
}
//# sourceMappingURL=derive-price-rule-fields.js.map